<template lang="pug">
    .purchase.full-height-error.not-valid(v-if="!enabledExtensions.includes('shop')")
        Error(:message="null" :code="403")
    .purchase.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    .purchase.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .purchase(v-else-if="$route.params.id === 'new'")
        NewPurchaseStepper(:loading="loading")
    .purchase(v-else)
        tabs(:items="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                el-button.cancel-button(
                    circle v-if="! loading && isCancelable"
                    type="danger"
                    icon="el-icon-fa-ban fas"
                    :loading="canceling"
                    :disabled="isDisabledSubmit && ! canceling"
                    @click="cancelPurchaseModalVisibility = true"
                )
                el-button.delete-button(
                    circle v-if="! loading && isCancelable"
                    type="warning"
                    icon="el-icon-fa-undo fas"
                    :loading="partialCanceling"
                    :disabled="isDisabledSubmit && ! partialCanceling"
                    @click="partialCancelPurchaseDrawerVisibility = true"
                )
                el-button.activate-button(
                    circle v-if="! loading && status === 'new' && form.sold_by !== 'point-of-sale'"
                    type="success"
                    icon="el-icon-fa-tasks fas"
                    :disabled="! statusOptionsLoeded"
                    @click="editPurchase"
                )
                //- el-button.activate-button(
                //-     circle v-if="! loading && !inactive && status === 'new' || ! loading && status === 'processing'"
                //-     type="info"
                //-     icon="el-icon-fa-dolly fas"
                //-     :disabled="! statusOptionsLoeded"
                //-     @click="shipPurchase"
                //- )
                template(
                    v-if="(!(['new', 'undefined'].includes(status) && form.sold_by !== 'point-of-sale') || !id || form.canceled_at) && microserviceButtons && microserviceButtons.left && microserviceButtons.left.length"
                    v-for="microservice in microserviceButtons.left"
                )
                    MicroserviceButton(
                        :data="form"
                        :config="microservice"
                        appearance="circle"
                        @error="microserviceError"
                        @success="microserviceSuccess"
                    )
                el-button(
                    circle icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                )
                el-button(
                    circle v-if="! loading && ! inactive"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :disabled="isDisabledSubmit && ! savingAndClose"
                    :loading="savingAndClose"
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle v-if="! loading && ! inactive"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :disabled="isDisabledSubmit && ! saving"
                    :loading="saving"
                    @click="submit"
                )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            all-input-fields
            el-card.no-padding(shadow="always" v-loading="loading")
                router-view.purchase-form(:key="$route.path" :class="{'loading-panel': loading}")
            .buttons-flex
                .form-buttons
                    el-button.cancel-button(
                        round v-if="! loading && isCancelable"
                        type="danger"
                        icon="el-icon-fa-ban fas"
                        :loading="canceling"
                        :disabled="isDisabledSubmit && ! canceling"
                        @click="cancelPurchaseModalVisibility = true"
                    ) {{ $t('Cancel') }}
                    el-button.delete-button(
                        round v-if="! loading && isCancelable"
                        type="warning"
                        icon="el-icon-fa-undo fas"
                        :loading="partialCanceling"
                        :disabled="isDisabledSubmit && ! partialCanceling"
                        @click="partialCancelPurchaseDrawerVisibility = true"
                    ) {{ $t('Partially Cancel') }}
                    el-button.activate-button(
                        round v-if="! loading && status === 'new' && form.sold_by !== 'point-of-sale'"
                        type="success"
                        icon="el-icon-fa-tasks fas"
                        :disabled="! statusOptionsLoeded"
                        @click="editPurchase"
                    ) {{ $t('Edit') }}
                    //- el-button.activate-button(
                    //-     round v-if="! loading && !inactive && status === 'new' || ! loading && status === 'processing'"
                    //-     type="info"
                    //-     icon="el-icon-fa-dolly fas"
                    //-     :disabled="! statusOptionsLoeded"
                    //-     @click="shipPurchase"
                    //- ) {{ $t('Shipped') }}
                    template(
                        v-if="(!(['new', 'undefined'].includes(status) && form.sold_by !== 'point-of-sale') || !id || form.canceled_at) && microserviceButtons && microserviceButtons.left && microserviceButtons.left.length"
                        v-for="microservice in microserviceButtons.left"
                    )
                        MicroserviceButton(
                            :data="form"
                            :config="microservice"
                            @error="microserviceError"
                            @success="microserviceSuccess"
                        )
                .form-buttons
                    el-button(
                        round v-if="! loading"
                        icon="el-icon-fa-times fas"
                        :disabled="isDisabledSubmit"
                        @click="leave"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        round v-if="! loading && ! inactive"
                        type="primary"
                        icon="el-icon-fa-check fas"
                        :loading="savingAndClose"
                        :disabled="isDisabledSubmit && ! savingAndClose"
                        @click="submit($event, listRoute)"
                    ) {{ $t('Save and close') }}
                    el-button(
                        round v-if="! loading && ! inactive"
                        type="success"
                        icon="el-icon-fa-save fas"
                        :loading="saving"
                        :disabled="isDisabledSubmit && ! saving"
                        @click="submit"
                    ) {{ $t('Save') }}

        el-dialog.cancel-purchase-dialog(
            :title="$t('Are you sure you want to cancel this purchase?')"
            :visible.sync="cancelPurchaseModalVisibility"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            top="10vh"
            width="460px"
            @closed="resetCancelPurchaseModal"
        )
            el-form.property-modal-form(
                ref="cancelPurchaseForm"
                :model="cancelPurchaseForm"
                label-position="top"
                :rules="cancelPurchaseRules"
                v-loading="cancelPurchaseModalLoading"
                @submit.prevent.native
            )
                transition(name="slide-vertical")
                    .modal-body(v-if="! cancelPurchaseModalLoading")
                        //- el-alert(
                        //-     type="info"
                        //-     :title="$t('Stock')"
                        //-     :description="$t('Stock is going back to the corresponding warehouse')"
                        //-     :closable="false"
                        //-     show-icon
                        //- )
                        .alert.info
                            i.el-icon-info
                            .text
                                b {{ $t('Stock management') }}
                                p {{ $t('Stock is going back to the corresponding warehouse') }}
            template(slot="footer")
                el-button(
                    size="mini"
                    icon="el-icon-fa-times fas"
                    @click="closeCancelPurchaseModal"
                ) {{ $t('Dismiss') }}
                el-button(
                    :disabled="cancelPurchaseModalLoading"
                    size="mini"
                    type="danger"
                    icon="el-icon-fa-check fas"
                    @click="cancelPurchase"
                ) {{ $t('Cancel irrevocably') }}

        el-drawer(
            :title="$t('Partially Cancel')"
            :visible.sync="partialCancelPurchaseDrawerVisibility"
            :close-on-press-escape="false"
            :wrapper-closable="false"
            :modal="true"
            size="90%"
            @closed="resetPartialCancelPurchaseDrawer"
        )
            el-form.partially-cancel(
                ref="partialCancelPurchaseForm"
                :model="partialCancelPurchaseForm"
                label-position="top"
                :rules="partialCancelPurchaseRules"
                v-loading="partialCancelPurchaseDrawerLoading"

                @submit.prevent.native
            )
                PartiallyCancelForm(
                    v-if="partialCancelPurchaseDrawerVisibility"
                    :purchase="form"
                    :form="partialCancelPurchaseForm"
                    :initializing.sync="partialCancelPurchaseDrawerLoading"
                    :visibility.sync="partialCancelPurchaseDrawerVisibility"
                )
            .drawer-footer
                .left
                    el-button(
                        icon="el-icon-fa-times fas"
                        @click="closePartialCancelPurchaseDrawer"
                    ) {{ $t('Dismiss') }}
                .right.flex-row
                    el-checkbox(
                        border
                        v-model="partialCancelPurchaseForm.notify"
                    ) {{ $t('Notify customer via email') }}
                    el-button(
                        type="danger"
                        icon="el-icon-fa-check fas"
                        :loading="partialCancelPurchaseDrawerSaving"
                        :disabled="partialCancelPurchaseDrawerLoading"
                        @click="cancelPurchasedItems"
                    ) {{ $t('Cancel irrevocably') }}
</template>

<i18n>
{
    "de": {
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Purchase could not be fetched.": "Bestellung konnte nicht gefunden werden.",
        "Purchase could not be saved.": "Bestellung konnte nicht gespeichert werden.",
        "Purchase saved successfully!": "Bestellung erfolgreich gespeichert!",
        "Purchase canceled successfully!": "Bestellung erfolgreich storniert!",
        "Purchase could not be canceled.": "Bestellung konnte nicht storniert werden.",
        "Purchase Not Found": "Bestellung nicht gefunden",
        "Are you sure you want to cancel this purchase?": "Soll diese Bestellung wirklich storniert werden?",
        "Cancel irrevocably": "Unwiderruflich stornieren",
        "Partially Cancel": "Teilweise stornieren",
        "Stock management": "Lagerverwaltung",
        "Stock is going back to the corresponding warehouse": "Der Bestand geht zurück in das entsprechende Lager",
        "Notify customer via email": "Kunden per E-Mail benachrichtigen",
        "Purchase": "Bestellung",
        "Customer": "Käufer",
        "Articles": "Artikel",
        "Shopping cart": "Warenkorb",
        "Cancel": "Stornieren",
        "Partially Cancel": "Teilweise stornieren",
        "Edit": "In Bearbeitung",
        "Shipped": "Versendet"
    }
}
</i18n>

<script>
import _ from 'lodash';
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { adminClient as apolloClient } from '@/store/apollo'

import store from '@/store';
import router from '@/router';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';
import MicroserviceButton from '@/components/MicroserviceButton';
import PurchaseApi from '@/extensions/shop/store/api/purchase';

// validate all fields, regardless if the corresponding component is mounted or not
import AllInputFields from './AllInputFields';
import NewPurchaseStepper from './NewPurchaseStepper';
import PartiallyCancelForm from './Partials/PartiallyCancelForm';

export default {
    name: 'Purchase',
    data() {
        return {
            listRoute: { name: 'purchases' },
            error: false,
            pathNotValid: false,
            loading: false,
            saving: false,
            savingAndClose: false,
            canceling: false,
            partialCanceling: false,

            cancelPurchaseModalVisibility: false,
            cancelPurchaseModalLoading: false,
            cancelPurchaseForm: {},
            cancelPurchaseRules: {},

            partialCancelPurchaseDrawerVisibility: false,
            partialCancelPurchaseDrawerLoading: false,
            partialCancelPurchaseDrawerSaving: false,
            partialCancelPurchaseForm: {
                items: [],
                credited_amount_net: 0,
                credited_amount: 0,
                comment: '',
                notify: true,
            },
            partialCancelPurchaseRules: {},
        };
    },
    components: {
        Tabs,
        Error,
        MicroserviceButton,
        AllInputFields,
        NewPurchaseStepper,
        PartiallyCancelForm,
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.setInitializedFlag(false);
                this.initialize();
            }
        }
    },
    computed: {
        id() {
            return _.get(this.form, 'id', false);
        },
        isCancelable() {
            return !!this.id && !this.form.canceled_at && !this.form.closed_at;
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.canceling || this.partialCanceling;
        },
        tabs() {
            const id = this.$route.params.id;

            let tabs = [];
            tabs.push({
                name: this.$t('Purchase'),
                path: `/sales/order/${id}/main`,
                icon: {
                    name: 'euro-sign',
                    group: 'fas'
                }
            })
            // if (this.form.sold_by !== 'point-of-sale' || _.has(this.form.purchaser, 'customer.id')) {
            tabs.push({
                name: this.$t('Customer'),
                path: `/sales/order/${id}/customer`,
                icon: {
                    name: 'user-alt',
                    group: 'fas'
                }
            })
            // }
            tabs.push({
                name: this.$t('Articles'),
                path: `/sales/order/${id}/articles`,
                icon: {
                    name: 'tags',
                    group: 'fas'
                }
            })

            return tabs;
        },
        status() {
            return _.get(this.form, 'status.key', 'undefined');
        },
        inactive() {
            // 'closed', 'canceled'
            return ['new', 'undefined'].includes(this.status) || !this.id || this.form.canceled_at || this.form.closed_at;
        },
        statusOptionsLoeded() {
            return this.options.status.items.length && this.options.status.loading === false;
        },
        microservices() {
            const settings = this.settingValues;

            const all = _.get(this.activeCms, 'config.template.microservices') || [];
            const filtered = all.filter(el => el.component === 'Purchase');

            // eslint-disable-next-line no-unused-vars
            const data = this.form;

            let allowed = [];
            filtered.forEach(microservice => {
                let valid = true;
                try {
                    const conditions = microservice.conditions;
                    if (conditions && conditions.length) {
                        conditions.forEach(o => {
                            if (valid === false) return;

                            const { type, condition } = o;
                            switch (type) {
                                case 'eval':
                                    valid = eval(condition);
                                    break;

                                default:
                                    valid = false;
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                    valid = false;
                }

                if (valid) allowed.push(microservice);
            });

            return allowed;
        },
        microserviceButtons() {
            let microservices = {};

            this.microservices.forEach(microservice => {
                if (microservice.button) {
                    const position = _.get(microservice, 'button.position') || 'default';
                    if (!microservices[position]) microservices[position] = [];
                    microservices[position].push(microservice);
                }
            });

            return microservices;
        },
        ...mapGetters({
            form: 'ext_shop_purchase/form',
            options: 'ext_shop_purchase/options',
            initialized: 'ext_shop_purchase/form_initialized',
            validateOnEnter: 'ext_shop_purchase/form_validateOnEnter',
            rules: 'ext_shop_purchase/rules',

            settingValues: 'settingValues',

            // cms
            activeCms: 'activeCms',
            enabledExtensions: 'enabledExtensions'
        })
    },
    methods: {
        initialize() {
            if (!this.enabledExtensions.includes('shop')) {
                this.setInitializedFlag(true);
                return;
            }

            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                const fetchDependencies = () => {
                    let actions = [
                        this.fetchShippingMethodOptions(this.activeCms.shop.id),
                        this.fetchPaymentMethodOptions(this.activeCms.shop.id),
                        this.fetchStatusOptions(this.activeCms.shop.id),
                        this.fetchIndicatorOptions(),
                        // this.fetchCategoryOptions(this.activeCms.id),
                        this.fetchStockOptions(this.activeCms.shop.id),
                        this.fetchTaxOptions(this.activeCms.shop.id),

                        this.fetchCustomerGroupOptions(this.activeCms.shop.id),
                        this.fetchTagOptions(this.activeCms.id),
                    ];

                    if (this.$route.params.id !== 'new') {
                        this.definePurchasedItemsPaginationSizes([5, 10, 50]);
                        this.definePurchasedItemsPerPage(10);
                        actions.push(
                            this.fetchPurchasedItemsPaginated({
                                scope: 'ex',
                                type: 'shop_purchase_article',
                                includeInternals: true,
                                includeWebShopPurchases: true,
                                includePointOfSalePurchases: true,
                            }).finally(() => {
                                this.updatePurchasedItemsLoading(false);
                            })
                        );
                    }

                    return Promise.all(actions);
                }

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    // this.leave();

                    const purchaser = _.cloneDeep(this.form.purchaser)
                    store.dispatch('ext_shop_purchase/reset');
                    if (purchaser) store.commit('ext_shop_purchase/form/purchaser', purchaser);

                    fetchDependencies()
                        .catch(handleDependencyError)
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.fetchPurchase(this.$route.params.id)
                        .then(() => {
                            // store.commit('ext_shop_purchase/resetUI')

                            this.loading = false;

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    store.commit('ext_shop_purchase/resetRules');
                                    // store.commit('ext_shop_purchase/resetUI')
                                })
                                .catch(handleDependencyError);
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Purchase Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Purchase could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        resetCancelPurchaseModal() {
            this.$refs.cancelPurchaseForm.resetFields();
        },
        closeCancelPurchaseModal() {
            this.cancelPurchaseModalVisibility = false;
        },
        resetPartialCancelPurchaseDrawer() {
            this.partialCancelPurchaseForm = {
                items: [],
                credited_amount_net: 0,
                credited_amount: 0,
                comment: '',
                notify: true,
            },

            this.$refs.partialCancelPurchaseForm.resetFields();
        },
        closePartialCancelPurchaseDrawer() {
            this.partialCancelPurchaseDrawerVisibility = false;
        },
        // eslint-disable-next-line
        microserviceError({ key, error, callback }) {
            const callbacks = {
                refetchLogs: this.refetchLogs,
                refetch: this.refetch,
                // ...
            };

            // run callback
            if (callback)
                callbacks[callback]().finally(() => this.updateMicroserviceProcessing({ key, status: false }));
            else this.updateMicroserviceProcessing({ key, status: false });
        },
        // eslint-disable-next-line
        microserviceSuccess({ key, error, callback }) {
            const callbacks = {
                refetchLogs: this.refetchLogs,
                refetch: this.refetch,
                // ...
            };

            setTimeout(() => {
                // run callback
                if (callback) {
                    callbacks[callback]().finally(() => this.updateMicroserviceProcessing({ key, status: false }));
                } else {
                    this.updateMicroserviceProcessing({ key, status: false });
                }
            }, 1000)

            // this.editPurchase()
        },
        async refetch() {
            await apolloClient.clearStore()
            await new Promise(resolve => setTimeout(resolve, 0));

            return this.fetchPurchase(this.$route.params.id)
                .catch(err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    } else {
                        this.error = true;
                    }

                    switch (code) {
                        case 401:
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        case 404:
                            this.error = { code, message: 'Purchase Not Found' };
                            break;
                        default:
                            this.$notify.error({
                                title: this.$t('An error occurred!'),
                                message: this.$t('Purchase could not be fetched.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                            break;
                    }

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                });
        },
        cancelPurchase() {
            this.closeCancelPurchaseModal();

            const previousStatus = _.get(this.form, 'status');

            const status = this.options.status.items.find(el => el.key === 'canceled');
            if (status) this.setStatus(status);

            this.submit('cancel')
                .catch(() => {
                    this.setStatus(previousStatus)
                });

            // this.delete(this.id)
            //     .then(() => {
            //         // this.canceling = false
            //
            //         router.push(this.listRoute)
            //
            //         this.$notify.success({
            //             title: this.$t('Purchase deleted successfully!'),
            //             iconClass: 'fas el-icon-fa-check',
            //             position: 'bottom-left',
            //             customClass: 'dark',
            //             duration: 8000,
            //         })
            //     })
            //     .catch(err => {
            //         [> eslint no-console: ["error", { allow: ["error"] }] <]
            //         console.error(err)
            //
            //         this.canceling = false
            //
            //         this.$notify.error({
            //             title: this.$t('An error occurred!'),
            //             message: this.$t('Purchase could not be deleted.'),
            //             iconClass: 'fas el-icon-fa-times',
            //             position: 'bottom-left',
            //             customClass: 'dark',
            //             duration: 8000,
            //         })
            //     })
        },
        cancelPurchasedItems() {
            this.partialCancelPurchaseDrawerSaving = true;

            let cancellation = this.partialCancelPurchaseForm;
            cancellation.purchase = { id: this.form.id }

            return PurchaseApi.cancelPurchasedItems(cancellation)
                .then(async cancellation => {
                    await apolloClient.clearStore();

                    const fetchPurchase = this.fetchPurchase(this.$route.params.id)
                    const fetchPurchasedItems = this.fetchPurchasedItemsPaginated({
                        scope: 'ex',
                        type: 'shop_purchase_article',
                        includeInternals: true,
                        includeWebShopPurchases: true,
                        includePointOfSalePurchases: true,
                    })

                    return Promise.all([fetchPurchase, fetchPurchasedItems])
                        .then(() => {
                            this.closePartialCancelPurchaseDrawer();
                            this.partialCancelPurchaseDrawerSaving = false;
                        })
                        .finally(() => {
                            this.partialCancelPurchaseDrawerSaving = false;
                        });
                })
                .catch(() => {
                    this.partialCancelPurchaseDrawerSaving = false;
                });
        },
        async submit(event, redirect = false) {
            return new Promise((resolve, reject) => {
                this.$refs.form.validate((valid, errors) => {
                    if (valid) {
                        if (redirect) this.savingAndClose = true;
                        else if (event === 'cancel') this.canceling = true;
                        else this.saving = true;

                        let data = _.cloneDeep(this.form);
                        if (event === 'cancel') {
                            data = {
                                id: this.form.id,
                                status: this.form.status,
                            }
                        }

                        this.update(data)
                            .then(() => {
                                if (redirect) this.savingAndClose = false;
                                else if (event === 'cancel') this.canceling = false;
                                else this.saving = false;

                                if (event === 'cancel') {
                                    let notification = {
                                        title: this.$t('Purchase canceled successfully!'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    };
                                    this.$notify.warning(notification);
                                } else {
                                    let notification = {
                                        title: this.$t('Purchase saved successfully!'),
                                        iconClass: 'fas el-icon-fa-check',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    };
                                    this.$notify.success(notification);
                                }

                                if (redirect) router.push(redirect);
                                resolve();
                            })
                            .catch(err => {
                                /* eslint no-console: ["error", { allow: ["error"] }] */
                                console.error(err);

                                if (redirect) this.savingAndClose = false;
                                else if (event === 'cancel') this.canceling = false;
                                else this.saving = false;

                                let notification = {
                                    title: this.$t('An error occurred!'),
                                    message: this.$t('Purchase could not be saved.'),
                                    iconClass: 'fas el-icon-fa-times',
                                    position: 'bottom-left',
                                    customClass: 'dark',
                                    duration: 8000
                                };
                                if (event === 'cancel') {
                                    notification = {
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Purchase could not be canceled.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    };
                                }
                                this.$notify.error(notification);

                                reject(err);
                            });
                    } else {
                        this.setValidateOnEnterFlag(true);

                        // check the invalid fields
                        // and go to the corresponding tab
                        // or open the corresponding closed area
                        // TODO: scroll to invalid field

                        let invalidTabs = [];
                        _.each(errors, (error, path) => {
                            if (_.indexOf(['name'], path) >= 0) {
                                invalidTabs.push(`/sales/order/${this.$route.params.id}/main`);
                            }
                        });

                        invalidTabs = _.uniq(invalidTabs);

                        // check if the current tab
                        // is present in invalidTabs
                        // if not, go to next (first) invalid tab

                        const match = _.indexOf(invalidTabs, this.$route.fullPath);

                        // let switchTab = false;
                        if (match < 0) {
                            invalidTabs.every(invalidTab => {
                                if (invalidTab && this.activeTab !== invalidTab) {
                                    const tab = _.find(this.tabs, { path: invalidTab });
                                    if (tab) {
                                        this.activateTab(tab);

                                        // break loop after the first tab has been activated
                                        return false;
                                    }
                                }
                            });
                        }

                        // // triger the validation again
                        // // so the previously hidden fields will get the errors
                        // // ---
                        // // does not work if the component has been destroyed
                        // // in the meantime (f.a. by switching tabs)
                        // if (switchTab === false) {
                        //     const form = this.$refs.form
                        //     setTimeout(() => {
                        //         form.validate(() => {
                        //             // do nothing
                        //             // callback function is required :(
                        //         })
                        //     }, 1000);
                        // }

                        this.$notify.warning({
                            title: this.$t('Form is not valid!'),
                            message: this.$t('Correct your input and submit again.'),
                            iconClass: 'fas el-icon-fa-exclamation-circle',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });

                        reject('invalid');
                    }
                });
            });
        },
        editPurchase() {
            // update status to 'processing'
            const previousStatus = _.get(this.form, 'status');

            const status = this.options.status.items.find(el => el.key === 'processing');
            if (status) {
                this.setStatus(status);
                this.submit()
                    .catch(() => {
                        this.setStatus(previousStatus)
                    });
            }
        },
        shipPurchase() {
            // update status to 'shipped'
            const previousStatus = _.get(this.form, 'status');

            const status = this.options.status.items.find(el => el.key === 'shipped');
            if (status) {
                this.setStatus(status);
                this.submit()
                    .catch(() => {
                        this.setStatus(previousStatus)
                    });
            }
        },
        leave() {
            router.push(this.listRoute);
        },
        ...mapMutations({
            setInitializedFlag: 'ext_shop_purchase/form_initialized',
            setValidateOnEnterFlag: 'ext_shop_purchase/form_validateOnEnter',
            setStatus: 'ext_shop_purchase/form/status',
            updateMicroserviceProcessing: 'microservices/updateProcessing',

            updatePurchasedItemsLoading: 'ext_shop_purchase/updatePurchasedItemsPaginationLoading',
            // definePurchasedItemsFilterValue: 'ext_shop_purchase/definePurchasedItemsFilterValue',
            definePurchasedItemsPaginationSizes: 'ext_shop_purchase/definePurchasedItemsPaginationSizes',
            definePurchasedItemsPerPage: 'ext_shop_purchase/definePurchasedItemsPerPage'
        }),
        ...mapActions({
            activateTab: 'activateTab',
            fetchPurchase: 'ext_shop_purchase/fetchPurchase',
            refetchLogs: 'ext_shop_purchase/refetchLogs',

            fetchStatusOptions: 'ext_shop_purchase/fetchStatusOptions',
            fetchIndicatorOptions: 'ext_shop_purchase/fetchIndicatorOptions',
            // fetchCategoryOptions: 'ext_shop_purchase/fetchCategoryOptions',
            fetchStockOptions: 'ext_shop_purchase/fetchStockOptions',
            fetchShippingMethodOptions: 'ext_shop_purchase/fetchShippingMethodOptions',
            fetchTaxOptions: 'ext_shop_purchase/fetchTaxOptions',
            fetchPaymentMethodOptions: 'ext_shop_purchase/fetchPaymentMethodOptions',

            fetchCustomerGroupOptions: 'ext_shop_purchase/fetchCustomerGroupOptions',
            fetchTagOptions: 'ext_shop_purchase/fetchTagOptions',

            // create: 'ext_shop_purchase/create',
            update: 'ext_shop_purchase/update',
            // cancel: 'ext_shop_purchase/cancel',

            fetchPurchasedItemsPaginated: 'ext_shop_purchase/fetchPurchasedItemsPaginated',
        })
    },
    mounted() {
        this.initialize();
        this.$root.$on('trigger-save', () => {
            this.submit()
        })
    },
    beforeRouteEnter(to, from, next) {
        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new';

        if (to.name === 'purchase-form' && id !== 'new') {
            next({ name: 'purchase-main', params: { id } });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        setTimeout(() => {
            store.dispatch('ext_shop_purchase/reset');
            store.commit('ext_shop_purchase/resetUI');
            this.$nextTick(() => store.commit('ext_shop_purchase/resetRules'));
        }, 300);
    },
    destroyed() {
        // console.log('destroyed');
        // geht nicht .. leert das Formular bei klick auf anderen Reiter
        // store.dispatch('ext_shop_purchase/reset')
    }
};
</script>

<style lang="sass" scoped>
.purchase::v-deep
    .el-card.no-padding
        .el-card__body
            padding: 0
            & > section
                padding: 20px
    .title
        font-weight: 400
        margin: 0
        margin-bottom: 10px
        .small
            font-size: .8em
            color: $--color-info
    .bordered-table
        // width: 500px
        .min
            width: 1px
        .centered-text
            text-align: center
        .el-icon-warning,
        .el-icon-warning-outline
            margin-right: 6px
            min-width: 1rem
            line-height: 1
            color: $--color-danger
        .flex-vertical-middle
            display: flex
            align-items: center
        .gray
            color: darken($color-grey-text, 10%)
        .danger
            color: $--color-danger
        hr
            margin: 0
    .purchase-form-main .flex .bordered-table
        td
            padding: 8px 0
    .flex
        table.bordered-table.panel
            font-size: 14px
            width: auto
            flex-basis: 300px
            place-self: flex-start
            background: $color-body
            border-color: transparent
            border-radius: 4px
            td
                border-color: transparent
                padding: 6px 15px
            tr:first-of-type
                td
                    padding-top: 10px
            tr:last-of-type
                td
                    padding-bottom: 10px
            .el-loading-mask
                background-color: rgba($color-body, .8)
            .spinner
                position: absolute
                left: calc(50% - 13px)
                top: calc(50% - 18px)
                z-index: 3000
        table.bordered-table + .grow
            margin-top: 36px
        .grow
            flex-grow: 1
            place-self: flex-start
            width: auto
        .timeline
            min-width: 240px
            max-width: 400px
            margin-top: 30px
            ul
                padding-left: 18px
        +res(lg)
            display: flex
            table.bordered-table + .grow
                margin-top: 0
                margin-left: 20px
            .timeline
                margin-top: 0
                ul
                    padding-left: 2rem

    .preview .annotationLayer
        display: none !important

    .el-timeline-item.success
        .el-timeline-item__tail
            border-color: $--color-success
    .el-timeline-item.half-success
        .el-timeline-item__tail:before
            content: ''
            position: absolute
            left: -2px
            top: 0
            height: 50%
            width: 2px
            background: $--color-success
            border-radius: 2px

.buttons-flex .delete-button
    margin-right: 20px

.modal-body
    .alert
        display: flex
        align-items: center
        margin: 0
        i
            opacity: 0.6
            min-width: 2rem
            font-size: 1.4rem

.microservice-button-container + .el-button
    margin-left: 10px

.el-form.partially-cancel
    display: flex
    flex-direction: column
</style>
